import React, {useState, useEffect} from "react";
import { Button, Icon } from '@rebrandly/styleguide'
import './DefaultHeader.css'
import SignUpButton from "../SignUpButton"
import NavLink from "./NavLink";

const DefaultHeader = () => {
    const [open, setOpen] = useState(false);
    const [activeLink, setActiveLink] = useState(undefined);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setActiveLink(window.location.pathname);
        }
    }, []);
    return (
        <div
            id='desktop-nav'
            className='DefaultHeader__navbar'>
            <a className='DefaultHeader__logo' href='https://rebrandly.com' target='_blank'>Powered by <img src='/images/url-shortener.svg' alt='Url shortener' className='logo-header' width={110} height={28}/></a>
            <div className='container nav'>
                <div className='DefaultHeader__nav-links w-hidden-medium w-hidden-small'>
                    <NavLink
                        className='DefaultHeader__nav-link p-12 flex center-xs'
                        href='/'
                        icon='ic-link'
                        children='Free URL shortener'
                        setActiveLink={() => setActiveLink('/')}
                        activeLink={activeLink}
                    />
                    <NavLink
                        className='DefaultHeader__nav-link p-12 flex center-xs'
                        href='/qr-code-generator'
                        icon='ic-link'
                        children='Free QR Code Generator'
                        setActiveLink={() => setActiveLink('/qr-code-generator')}
                        activeLink={activeLink}
                    />
                </div>
            </div>
            <div className='DefaultHeader__button-sign_up w-hidden-medium w-hidden-small'>
                <SignUpButton className='full-width'><Button theme='primary' size='lg' className='full-width'><span className='font-bold'>Sign up for free</span></Button></SignUpButton>
            </div>
            <div className={`DefaultHeader__button-nav ${open ? 'open' : ''}`} onClick={() => setOpen(!open)}>
                <Icon name='ic-menu' color='var(--color-black)'/>
            </div>
            <div className={`DefaultHeader__nav-overlay ${open ? 'open' : ''}`}>
                <nav role='navigation' className={`DefaultHeader__nav-menu ${open ? 'open' : ''}`}>
                    <span className='w-hidden-main'>
                       <NavLink
                           className='DefaultHeader__nav-link-menu p-12 flex center-xs'
                           href='/'
                           children='Free URL shortener'
                           setActiveLink={() => setActiveLink('/')}
                           activeLink={activeLink}
                       />
                        <NavLink
                            className='DefaultHeader__nav-link-menu p-12 flex center-xs'
                            href='/qr-code-generator'
                            children='Free QR Code Generator'
                            setActiveLink={() => setActiveLink('/qr-code-generator')}
                            activeLink={activeLink}
                        />
                    </span>
                </nav>
            </div>
        </div>
    )
}
export default DefaultHeader
